// app/javascript/controllers/ui/manifesto/tilt_controller.js

import { Controller } from "@hotwired/stimulus"

/**
 * Tilt Controller
 *
 * Лёгкий 3D-tilt при hover: rotateX/rotateY по положению курсора.
 * Плюс parallax-смещение для дочерних элементов с data-depth="N" (0..1).
 *
 * @usedby _counter_strip.html.erb, _hero.html.erb
 *
 * Usage:
 *   <div class="mf-tilt"
 *        data-controller="ui--manifesto--tilt"
 *        data-ui--manifesto--tilt-max-value="8">
 *     <span data-depth="0.5">foreground</span>
 *   </div>
 */
export default class extends Controller {
  static values = {
    max: { type: Number, default: 8 },     // max rotation (deg)
    perspective: { type: Number, default: 900 },
    reset: { type: Number, default: 400 }  // ms to reset on leave
  }

  connect() {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return
    if (matchMedia("(hover: none)").matches) return

    this.element.style.transformStyle = "preserve-3d"
    this.element.style.perspective = `${this.perspectiveValue}px`

    this.depthEls = this.element.querySelectorAll("[data-depth]")

    this.onMove = this.#onMove.bind(this)
    this.onLeave = this.#onLeave.bind(this)
    this.element.addEventListener("pointermove", this.onMove)
    this.element.addEventListener("pointerleave", this.onLeave)
  }

  disconnect() {
    this.element.removeEventListener("pointermove", this.onMove)
    this.element.removeEventListener("pointerleave", this.onLeave)
  }

  #onMove(e) {
    const r = this.element.getBoundingClientRect()
    const x = (e.clientX - r.left) / r.width - 0.5   // -0.5..0.5
    const y = (e.clientY - r.top) / r.height - 0.5
    const ry = x * this.maxValue * 2
    const rx = -y * this.maxValue * 2
    this.element.style.transition = "transform 120ms var(--mf-ease, ease-out)"
    this.element.style.transform = `rotateX(${rx}deg) rotateY(${ry}deg)`
    for (const el of this.depthEls) {
      const d = parseFloat(el.dataset.depth) || 0
      el.style.transform = `translate3d(${x * d * 20}px, ${y * d * 20}px, 0)`
    }
  }

  #onLeave() {
    this.element.style.transition = `transform ${this.resetValue}ms var(--mf-ease, ease-out)`
    this.element.style.transform = "rotateX(0deg) rotateY(0deg)"
    for (const el of this.depthEls) {
      el.style.transition = `transform ${this.resetValue}ms var(--mf-ease, ease-out)`
      el.style.transform = "translate3d(0, 0, 0)"
    }
  }
}
